import { Controller } from 'react-hook-form'

import { useFormContextContact } from '../_utils'
import ContactFormField from '../ContactFormField'

const FirstName = () => {
    const { control } = useFormContextContact()

    return (
        <Controller
            control={control}
            name="firstName"
            render={({ field, fieldState: { error } }) => (
                <ContactFormField
                    variant="input"
                    label="Prénom d’exercice"
                    disabled
                    status={{
                        error,
                        valid: Boolean(field.value),
                    }}
                    size="0.5"
                    dataCyScope="ContactField"
                    {...field}
                    onChange={(e) => {
                        field.onChange(e)
                    }}
                    value={field.value ?? ''}
                    placeholder="Prénom"
                />
            )}
        />
    )
}

export default FirstName
